import { CandidateAvailabilityFragment } from "generated/schemaTypes";
import { useMemo } from "react";
import { PersistableCalendarEvent } from "shared/guide-content/rich-blocks/calendar-utils/types";

export const useIsRevision = ({
  candidateAvailabilityId,
  forceIsRevision,
  candidateAvailability,
}: {
  candidateAvailabilityId: string;
  forceIsRevision?: boolean;
  candidateAvailability?: CandidateAvailabilityFragment;
}) => {
  const isRevisedAvailability = useMemo(() => {
    if (forceIsRevision) {
      return true;
    }
    if (!candidateAvailability?.availabilityRequest?.candidateAvailabilities) {
      return false;
    }

    const parentCandidateAvailabilities =
      candidateAvailability.availabilityRequest.candidateAvailabilities;
    const candidateAvailabilityIndex = parentCandidateAvailabilities.findIndex(
      (availability) => availability.id === candidateAvailabilityId
    );

    return candidateAvailabilityIndex > 0;
  }, [candidateAvailability, candidateAvailabilityId, forceIsRevision]);
  return isRevisedAvailability;
};

export const useSelectionsByCandidate = ({
  loading,
  candidateAvailability,
  availabilitiesFromLexical,
}: {
  loading: boolean;
  candidateAvailability?: CandidateAvailabilityFragment;
  availabilitiesFromLexical: PersistableCalendarEvent[];
}) => {
  const selectionsByCandidate = useMemo(
    () =>
      loading
        ? []
        : candidateAvailability?.calendarEvents.map((calendarEvent) => ({
            ...calendarEvent,
            allDay: calendarEvent.allDay ?? false,
          })) ??
          // When we create a render as an attachment to the message for sharing availability
          // we won't have a saved candidate availability yet so we can use the values from lexical state
          availabilitiesFromLexical.map((availability) => ({
            ...availability,
            start: availability.start
              ? new Date(availability.start)
              : undefined,
            end: availability.end ? new Date(availability.end) : undefined,
          })),
    [candidateAvailability, availabilitiesFromLexical, loading]
  );
  return selectionsByCandidate;
};
